<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>الحوافز والخصومات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع الحوافز والخصومات
                                <div v-show="$per.value.saveSalaryMovement" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                              <div class='form-group col-lg-4 col-sm-6'>
                                <h4 >الفرع:</h4>
                                <select class="form-control" v-model="filterBranche">
                                  <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div class='form-group col-lg-4 col-sm-6'>
                                <h4 >النوع:</h4>
                                <select class="form-control" v-model="filterType">
                                  <option v-for="item in filterTypes" :key="item.id" v-bind:value="item.id">
                                    {{ item.name }}
                                  </option>
                                </select>
                              </div>
                              <div style="padding:0px;margin:0px" class='form-group col-lg-4 col-sm-12'>
                                <div class='form-group col-lg-6 col-sm-6'>
                                  <h4 >الشهر:</h4>
                                  <Datepicker :minimumView="'month'" :maximumView="'month'" :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='filterMonth'></Datepicker>
                                </div>
                                <div class='form-group col-lg-6 col-sm-6'>
                                  <h4 >&nbsp;</h4>
                                  <button v-show="$per.value.getSalaryMovementFilter" @click='search' type='button' class='btn btn-primary btn-block'>عرض</button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>الموظف</th>
                                          <th style='text-align: center'>الحركة</th>
                                          <th style='text-align: center'>المبلغ</th>
                                          <th style='text-align: center'>الشهر</th>
                                          <th style='text-align: center'>ملاحظات</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.name}}</td>
                                          <td align='center'>{{record.type}}</td>
                                          <td align='center'>{{record.amount}}</td>
                                          <td align='center'>{{record.month}}</td>
                                          <td align='center'>{{record.notes}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteSalaryMovement" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editSalaryMovement" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>الفرع:</label>
                                     <select  @change='GetEmp()' class="form-control"  v-model="record.branche_id">
                                       <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>الموظف:</label>
                                     <select class="form-control"  v-model="record.emp_id">
                                       <option v-for="item in emps" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-3'>
                                     <label>الحركة:</label>
                                     <select class="form-control"  v-model="record.movements">
                                       <option v-for="item in types" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-3'>
                                     <label>المبلغ:</label>
                                     <input v-model='record.amount' class='form-control' name='amount' type='text'>
                                 </div>
                                 <div class='form-group col-lg-2 col-sm-6'>
                                     <label>الشهر:</label>
                                     <Datepicker :minimumView="'month'" :maximumView="'month'" :typeable="true" :format="customFormatter" :language="ar" :bootstrap-styling="true" v-model='record.month'></Datepicker>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-12'>
                                     <label>ملاحظات:</label>
                                     <input v-model='record.notes' class='form-control' name='notes' type='text'>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {ar} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
export default {
  components: {
    Datepicker
  },
  name: 'salaryMovement',
  data () {
    return {
      ar: ar,
      validationErrors: '',
      records: {},
      record: {},
      emps: {},
      types: [{id: 1, name: 'خصم'}, {id: 0, name: 'حافز'}],
      filterTypes: [{id: 2, name: ''}, {id: 1, name: 'خصم'}, {id: 0, name: 'حافز'}],
      successShow: false,
      errorShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      branches: [],
      filterBranche: '',
      filterMonth: '',
      filterType: '',
      title: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.record.branche_id = this.branches[0].id
    this.GetData()
    this.filterMonth = new Date()
    this.filterBranche = localStorage.getItem('BrancheID')
  },
  methods: {
    GetEmp () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getBranchEmp', {
        token: localStorage.getItem('token'),
        branch_id: this.record.branche_id
      })
        .then(({ data }) => {
          this.emps = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM')
    },
    isNumber: function (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    search () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getSalaryMovementFilter', {
        token: localStorage.getItem('token'),
        branche_id: this.filterBranche,
        month: this.filterMonth,
        type: this.filterType
      })
        .then(({ data }) => {
          this.isLoadingData = false
          this.records = data
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getSalaryMovement', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.records = data
          this.GetEmp()
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branche_id': this.record.branche_id, 'emp_id': '', 'movements': '', 'amount': '', 'month': '', 'notes': '', 'user_id': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'branche_id': recID.branche_id, 'emp_id': recID.emp_id, 'movements': recID.movements, 'amount': recID.amount, 'month': recID.month, 'notes': recID.notes, 'user_id': recID.user_id}
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveSalaryMovement', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        branche_id: this.record.branche_id,
        emp_id: this.record.emp_id,
        movements: this.record.movements,
        amount: this.record.amount,
        month: this.record.month,
        notes: this.record.notes,
        user_id: this.record.user_id
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteSalaryMovement', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/SalaryMovement.vue